<script>
/* global axios */
// Botão de ligação BCVOZ (PABX Bravotech) no header da conversa. Aparece quando
// a caixa tem a integração BCVOZ ativa. O webphone é o widget NATIVO carregado
// globalmente do CDN (ver useBcvozWebphone) — ao clicar, só disca no widget já
// aberto via window.BCVoz.call(numero). Não abre URL nem janela própria.
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

export default {
  components: { ButtonV4 },
  data() {
    return { enabled: false };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
    }),
    inboxId() {
      return this.currentChat?.inbox_id;
    },
    phone() {
      return this.currentChat?.meta?.sender?.phone_number;
    },
    // Mostra o botão quando a integração BCVOZ está ativa na caixa.
    canShow() {
      return this.enabled;
    },
  },
  watch: {
    inboxId: {
      immediate: true,
      handler() {
        this.loadConfig();
      },
    },
  },
  methods: {
    async loadConfig() {
      this.enabled = false;
      if (!this.inboxId) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/kanban/bcvoz_tokens`,
          { params: { inbox_id: this.inboxId } }
        );
        this.enabled = !!data.data?.enabled && !!data.data?.has_token;
      } catch (e) {
        this.enabled = false;
      }
    },
    call() {
      if (!this.phone) {
        useAlert(this.$t('CONVERSATION.BCVOZ.NO_PHONE'));
        return;
      }
      const digits = String(this.phone).replace(/\D/g, '');
      // Disca no webphone global (carregado do CDN). Se ainda não carregou/
      // registrou, avisa em vez de falhar calado.
      if (window.BCVoz && typeof window.BCVoz.call === 'function') {
        window.BCVoz.call(digits);
        return;
      }
      useAlert(this.$t('CONVERSATION.BCVOZ.ERROR'));
    },
  },
};
</script>

<template>
  <ButtonV4
    v-if="canShow"
    v-tooltip="$t('CONVERSATION.BCVOZ.CALL')"
    size="sm"
    variant="ghost"
    color="slate"
    icon="i-ph-phone-fill"
    class="rounded-md hover:bg-n-alpha-2"
    @click="call"
  />
</template>
